import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import * as XLSX from "xlsx";

// Export to PDF
export const exportToPDF = (data, columns, filename, title) => {
  const doc = new jsPDF();
  const primary = [26, 35, 126]; // #1A237E Navy Blue

  // Top Accent Bar
  doc.setFillColor(...primary);
  doc.rect(0, 0, doc.internal.pageSize.getWidth(), 4, "F");
  
  // Add title
  doc.setFont("helvetica", "bold");
  doc.setTextColor(...primary);
  doc.setFontSize(18);
  doc.text(title, 14, 22);
  
  // Add date
  doc.setFont("helvetica", "normal");
  doc.setFontSize(9);
  doc.setTextColor(100, 110, 115);
  doc.text(`Generated on: ${new Date().toLocaleDateString()}`, 14, 30);
  
  // Prepare table data - convert to strings and handle special characters
  const tableData = data.map((row) => {
    return columns.map((col) => {
      let value = "";
      if (col.accessor) {
        value = col.accessor(row);
      } else {
        value = row[col.key] || "";
      }
      return String(value);
    });
  });

  // Add table
  autoTable(doc, {
    head: [columns.map((col) => col.header)],
    body: tableData,
    startY: 40,
    styles: { 
      font: "helvetica",
      fontSize: 9,
      cellPadding: 4,
      overflow: "linebreak",
      cellWidth: "wrap",
      textColor: [50, 50, 50]
    },
    headStyles: { 
      fillColor: primary, 
      textColor: 255, 
      fontStyle: "bold"
    },
    alternateRowStyles: { fillColor: [247, 249, 252] },
    margin: { top: 40, left: 14, right: 14 },
    didParseCell: function (data) {
      if (data.cell.text && data.cell.text.length > 0) {
        data.cell.text = data.cell.text.map(text => String(text));
      }
    }
  });

  // Footer
  const pageCount = doc.getNumberOfPages();
  for (let i = 1; i <= pageCount; i++) {
    doc.setPage(i);
    doc.setFontSize(8);
    doc.setTextColor(150, 150, 150);
    doc.text(
      `Page ${i} of ${pageCount}`, 
      doc.internal.pageSize.getWidth() - 14, 
      doc.internal.pageSize.getHeight() - 10, 
      { align: "right" }
    );
  }

  doc.save(`${filename}.pdf`);
};

// Export to Excel
export const exportToExcel = (data, columns, filename, sheetName) => {
  // Prepare worksheet data
  const worksheetData = [
    columns.map((col) => col.header), // Header row
    ...data.map((row) =>
      columns.map((col) => {
        if (col.accessor) {
          return col.accessor(row);
        }
        return row[col.key] || "";
      })
    ),
  ];

  // Create workbook and worksheet
  const wb = XLSX.utils.book_new();
  const ws = XLSX.utils.aoa_to_sheet(worksheetData);

  // Set column widths
  const colWidths = columns.map(() => ({ wch: 20 }));
  ws["!cols"] = colWidths;

  // Add worksheet to workbook
  XLSX.utils.book_append_sheet(wb, ws, sheetName || "Sheet1");

  // Save file
  XLSX.writeFile(wb, `${filename}.xlsx`);
};

